import React from 'react';
import { Button, Card, CardBody, Col } from 'reactstrap';
import { ModalSpecialty } from '../../components/specialties/ModalSpecialty';
import { TableStriped } from '../../components/tables/TableStriped';
import { TabSpeciality } from '../../constant';
import { useSpecialty } from '../../hooks/specialties/useSpecialty';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TitleDataTable } from '../../components/tableDataTable/TitleDataTable';

export const IndexSpecialties = ({activeTab}) => {

    const {
        specialties, method, handleInputChange, validaciones,
        name,
        toggle, modal, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,handleSearchSpecial,

        //Excel
        downloadExcelSpeciality,

        closeModalSpeciality,

        searchSpecial, handleClearFilter


    } = useSpecialty(activeTab);

     const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button 
                    color="primary" 
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_specialty)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    
                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button 
                    color="danger" 
                    size="sm"
                    onClick={() => handleDelete(rowData.id_specialty)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };


    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };



    return (
        <>
            <Card>
                <CardBody className="p-1">
                    <Col sm="12" className='p-l-0 p-r-0 pb-2 pt-3' >
                        <TitleDataTable
                            titleTable={TabSpeciality}
                            buttonActions={downloadExcelSpeciality}
                            titleButton="Descargar listado de especialidades"
                            isDisbled={false}
                            titleCreate="Crear Especialidad"
                            buttonActionsCreate={handleCreate}
                            actionInput={handleSearchSpecial}
                            valueFilter={searchSpecial}
                            filterLocalStorage={true}
                            cleanFilterLocalStorage={handleClearFilter}
                        />
                    </Col>
                   
                    <div className="table-responsive">

                        <DataTable 
                            value={specialties} 
                            paginator 
                            rows={10} 
                            rowsPerPageOptions={[10, 20, 50]} 
                            className="data-table p-datatable-striped p-datatable-sm"
                            responsiveLayout="scroll"
                            emptyMessage={
                                <div className="text-center">
                                    <img 
                                        src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} 
                                        style={{ width: "45%" }} 
                                        alt="Sin resultados" 
                                    />
                                    <br />
                                    <p className='badge badge-light-primary mt-2' style={{fontSize: "15px"}}>
                                        No hay coincidencias con la búsqueda.
                                    </p>
                                </div>
                            }
                            >
                            <Column header="#" body={(rowData, { rowIndex }) => rowIndex + 1} headerStyle={headerStyle} style={centerStyle}/>
                            <Column field="name" header="Nombre" headerStyle={headerStyle} style={centerStyle}/>
                            <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                        </DataTable>



                      
                    </div>
                </CardBody>
            </Card>
            <ModalSpecialty
                {
                    ...{
                        method, handleInputChange, validaciones,
                        name, toggle, modal, loading,
                        saveCreate, saveUpdate, saveDelete, closeModalSpeciality
                    }
                }
            />
        </>
    )
}
